module.exports = __webpack_public_path__ + "static/media/userRole.3ca58162.svg";